export default {
  subheadline: 'Tieto nastavenia určujú, ako Qmulus prezentuje vašu spoločnosť, napr. v hlavičke správ PDF.',
};
